<template>
  <div class="product-item-wrapper">
    <div
      @click="openProductDetail(product.id)"
      class="product-item"
    >
      <div class="product-image">
        <div
          class="buybox-label"
          :class="{'buybox-winner-background' : product.buyBoxOrder === 1}"
        >
          <img
            v-if="product.buyBoxOrder === 1"
            :src="`${$root.cdnUrl}assets/icon-buybox-big.svg`"
            alt="Buybox winner"
          >
          <img
            v-else
            :src="`${$root.cdnUrl}assets/buybox-lose-icon.svg`"
            alt="Buybox winner"
          >
          <template v-if="product.buyBoxOrder !== 1">
            {{ product.buyBoxOrder || '-' }}
          </template>
        </div>
        <list-image
          :src="productImage"
          width="100%"
        />
      </div>
      <div class="product-content">
        <div
          class="product-name"
          :class="{'on-sale': isOnSale}"
          @click="productOpen"
        >
          <span>{{ product.title }}</span>
        </div>
        <ul class="product-attributes">
          <li>
            <label><span>Barkod:</span> {{ product.barcode }}</label>
          </li>
          <li>
            <label><span>Stok:</span>
              <label>{{ product.quantity | formatQuantity }}</label>
            </label>
            <label v-if="product.size"><span>Beden:</span> {{ product.size }}</label>
          </li>
          <li>
            <label><span>Satış Fiyatı:</span>
              <label>{{ product.salePrice | formatPrice }}</label>
            </label>
          </li>
          <li>
            <label><span>Buybox Fiyatı:</span>
              <label>{{ product.buyBoxPrice | formatPrice }}</label>
            </label>
          </li>
        </ul>
      </div>
      <div class="product-btn">
        <img
          :src="`${$root.cdnUrl}assets/icon-arrow-right.svg`"
          alt="Right icon"
        >
      </div>
    </div>
    <CampaignLabel
      v-if="showCampaignLabel"
      :product="product"
    />
    <MaxPriceLabel
      v-if="showMaxPriceLabel"
      :product="product"
    />
  </div>
</template>
<script>
import mobile from '@/utils/mobile';
import routerPush from '@/mixins/routerPush';
import ListImage from './ListImage';
import imageUtils from '@/utils/images';
import MaxPriceLabel from './MaxPriceLabel';
import CampaignLabel from './CampaignLabel';

export default {
  components: { ListImage, MaxPriceLabel, CampaignLabel },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [routerPush],
  computed: {
    getSize () {
      if (this.product.attributes && this.product.attributes.length) {
        const attribute = this.product.attributes.filter(item => item.attributeName.toLowerCase() === 'beden')[0];
        return attribute ? (attribute.customValue || attribute.attributeValue) : '--';
      }
      return '---';
    },
    productImage () {
      const images = this.product.images;
      const image = images && images.length !== 0 ? images[0].url : `${this.$root.cdnUrl}/assets/default.jpg`;

      return imageUtils.getCdnImage(image, 'icon');
    },
    isOnSale () {
      return this.$route.name === 'ListingOnSale';
    },
    getProductUrl () {
      return `${this.$root.tyUrl}/x/x-p-${this.product.productContentId}?merchantId=${this.product.supplierId}`;
    },
    getProductDeeplinkUrl () {
      return `ty://?Page=Product&ContentId=${this.product.productContentId}&MerchantId=${this.product.supplierId}&PdpSource=seller_store`;
    },
    showCampaignLabel () {
      return this.product?.campaignProduct;
    },
    showMaxPriceLabel () {
      const diff = Date.now() - this.product?.campaignEndDate;
      return this.product?.campaignMaxPrice && diff < 0;
    },
  },
  methods: {
    push (params) {
      const route = this.$route.name;

      this.routerPush('ProductDetail', params, { query: { route } });
      this.$root.trackEvent({
        eventCategory: 'MobileAppListing',
        eventAction: 'üründetayclick',
        eventLabel: 'üründetayclick',
      });
    },
    productOpen (e) {
      if (this.isOnSale) {
        mobile.navigationDispatch({
          url: this.getProductUrl,
          deeplink: this.getProductDeeplinkUrl,
          type: 'Linking',
        });
        e.stopImmediatePropagation();
      }
    },
    openProductDetail (productId) {
      this.push({ productId: productId });
    },
  },
};
</script>
<style lang="scss" scoped>
  .product-item-wrapper {
    border-bottom: 1px solid #dee0eb;
    .product-item {
      padding: 10px 0;
      overflow: hidden;
      display: flex;

      &:last-child {
        border-bottom: 0;
      }

      .product-content {
        flex: 1;
        overflow: hidden;

        .product-name {
          font-size: 14px;
          font-weight: 500;
          color: #273142;
          line-height: 1;
          &.on-sale {
            text-decoration: underline;
          }
          & > span {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .product-attributes {
          list-style: none;
          margin: 0;
          padding: 0;
          font-size: 12px;
          line-height: 14px;
          margin-top: 4px;
          li {
            color: #273142;
            font-weight: 500;
            & > label {
              margin-top: 4px;
              display: inline-flex;
              align-items: center;

              span {
                color: #95a1b5;
                font-weight: normal;
                display: inline-block;
                margin-right: 2px;
              }
              & + label{
                margin-left: 5px;
              }
            }
            &:first-child{
              label {
                margin-top: 0;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }

      .product-image {
        max-width: 45px;
        min-width: 45px;
        height: 100%;
        overflow: hidden;
        margin-right: 5px;
        .buybox-label {
          display: flex;
          justify-content: center;
          gap: 5px;
          background: #F7F7FA;
          border-radius: 2px;
          margin-bottom: 5px;
          padding: 3px;
          color: #6E7787;
          font-size: 16px;
          font-weight: 500;
          img {
            width: 14px !important;
          }
        }
        .buybox-winner-background {
          background: #F4EDFF;
        }
        img {
          width: 100%;
        }
      }

      .product-btn {
        padding: 0 10px;
        display: flex;
        align-items: center;
      }
      ::v-deep .g-input{
        .content {
          border: none;
          input {
            padding: 0 !important;
          }
        }
      }
    }
  }
</style>
